export default __webpack_public_path__ + "static/fuel_up_back-8a2f63b5b0a3139ac5d8d37d7e31ce7b.webp";